import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import {Button, Table} from 'antd';
import { ExportOutlined, ImportOutlined } from '@ant-design/icons';
import FormImport from './FormImport'

@inject('apiToolsStore','uiState')
@observer
class SearchResult extends Component {
  state={
    addModalVisible: false,
  }
  handleImport=()=>{
    this.setState({
      importModalVisible: true
    })
  }
  handleCancelImport=()=>{
    this.setState({
      importModalVisible: false
    })
  }
  handleExport = () => {
    const { uiState } = this.props
    uiState.onChangeFetchingExport('/open/api/v1/apiTools/uploadDataResource/export', {}, `UploadDataResource.xlsx`)
  }
  getRowClassName = (record, index) => {
    let className = '';
    className = index % 2 === 0 ? 'oddRow' : 'evenRow';
    return className;
  }
  render() {
      return (
        <>
          <Table className='searchResult' dataSource={[{ name: 'Order' }]} pagination={false} rowKey="id" rowClassName={this.getRowClassName} bordered>
            <Table.Column title='Data Resource Name' dataIndex="name" key="name" />
            <Table.Column align='center' title="Action" key="Action" render={(text, record) => (
              <>
                <Button style={{marginRight: 10}} onClick={this.handleImport} type='link' title='Import' icon={<ImportOutlined />}/>
                <Button style={{marginRight: 10}} onClick={this.handleExport} type='link' title='Export' icon={<ExportOutlined />}/>
              </>
            )}/>
          </Table>
          {this.state.importModalVisible?<FormImport
            modalVisible={this.state.importModalVisible}
            handleCancel={this.handleCancelImport}
          />:null}
        </>
      );
  }
}

export default SearchResult;
